/**
 * 27 canonical roles, ported from NexTern's `ROLE_HIERARCHY_ANALYSIS.md`.
 * Grouped by hierarchy level (L1 platform → L7 partner).
 * `college_admin` and `company_admin` are intentionally omitted — legacy.
 */
export const PLATFORM_ROLES = [
    'platform_admin',
    'platform_operator',
    'platform_viewer',
];
export const GROUP_ROLES = [
    'group_admin',
    'group_manager',
    'group_accountant',
];
export const UNIVERSITY_ROLES = [
    'university_admin',
    'university_registrar',
    'university_exam_controller',
];
export const COLLEGE_ROLES = [
    'principal',
    'vice_principal',
    'tpo',
    'assistant_tpo',
    'registrar',
    'accountant',
    'admissions_officer',
];
export const DEPARTMENT_ROLES = [
    'hod',
    'placement_coordinator',
    'faculty',
    'mentor_faculty',
];
export const STUDENT_ROLES = ['student', 'student_representative'];
export const PARTNER_ROLES = [
    'partner_admin',
    'recruiter',
    'hiring_manager',
    'partner_accountant',
    'technical_panel',
];
export const ALL_ROLES = [
    ...PLATFORM_ROLES,
    ...GROUP_ROLES,
    ...UNIVERSITY_ROLES,
    ...COLLEGE_ROLES,
    ...DEPARTMENT_ROLES,
    ...STUDENT_ROLES,
    ...PARTNER_ROLES,
];
/** Which UI shell a role sees. Kollez has 8 personas across 27 backend roles. */
export const ROLE_SHELL = {
    platform_admin: 'platform',
    platform_operator: 'platform',
    platform_viewer: 'platform',
    group_admin: 'group',
    group_manager: 'group',
    group_accountant: 'group',
    university_admin: 'group',
    university_registrar: 'group',
    university_exam_controller: 'group',
    principal: 'principal',
    vice_principal: 'principal',
    tpo: 'tpo',
    assistant_tpo: 'tpo',
    registrar: 'tpo',
    accountant: 'tpo',
    admissions_officer: 'tpo',
    hod: 'hod',
    placement_coordinator: 'hod',
    faculty: 'faculty',
    mentor_faculty: 'faculty',
    student: 'student',
    student_representative: 'student',
    partner_admin: 'company',
    recruiter: 'company',
    hiring_manager: 'company',
    partner_accountant: 'company',
    technical_panel: 'company',
};
export const SHELLS = [
    'student',
    'tpo',
    'group',
    'company',
    'principal',
    'hod',
    'faculty',
    'platform',
];
export const HIERARCHY_LEVEL = {
    platform_admin: 1,
    platform_operator: 1,
    platform_viewer: 1,
    group_admin: 2,
    group_manager: 2,
    group_accountant: 2,
    university_admin: 3,
    university_registrar: 3,
    university_exam_controller: 3,
    principal: 4,
    vice_principal: 4,
    tpo: 4,
    assistant_tpo: 4,
    registrar: 4,
    accountant: 4,
    admissions_officer: 4,
    hod: 5,
    placement_coordinator: 5,
    faculty: 5,
    mentor_faculty: 5,
    student: 6,
    student_representative: 6,
    partner_admin: 7,
    recruiter: 7,
    hiring_manager: 7,
    partner_accountant: 7,
    technical_panel: 7,
};
//# sourceMappingURL=roles.js.map